import * as angular from 'angular';
import * as _ from 'lodash';
import { IDebugHelper } from 'v2/modules/core/debug-helper';

angular.module('cerego.v3Registration').controller('nativeAppLauncherCtrl', [
  '$scope',
  '$location',
  '$timeout',
  '$window',
  'DebugHelper',
  function(
    $scope: ng.IScope,
    $location: ng.ILocationService,
    $timeout: ng.ITimeoutService,
    $window: ng.IWindowService,
    DebugHelper: IDebugHelper
  ) {
    const ctrl = this;

    const debugId = DebugHelper.registerController('nativeAppLauncherCtrl', ctrl);
    // after upgrade to 1.5.3, remove $scope injection and rely on $onDestroy callback
    $scope.$on('$destroy', () => DebugHelper.unregister(debugId));

    // attach the query params on this url verbatim onto the native app link
    ctrl.nativeAppLink = 'ceregonativeapp://' + _.trimStart($location.url(), '/');

    $timeout(() => {
      // Attempt automatic redirect to native app on touch devices.
      // If touch device doesn't have app installed, then the user will see a button to go to web dashboard
      // and a button to try again with launching native app
      const isTouchDevice = $window.navigator.maxTouchPoints > 0;
      const redirectUrl = isTouchDevice ? ctrl.nativeAppLink : '/app/nav/dashboard';
      $window.location.href = redirectUrl;
    });

    return ctrl;
  }
]);
